/**
 * Shared display formatters for admin UI dates.
 * Dates: dd/mm/yyyy · Datetimes: dd/mm/yyyy HH:mm:ss
 */

const pad2 = (n: number): string => String(n).padStart(2, '0');

const toValidDate = (value: string | number | Date | null | undefined): Date | null => {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  // Date-only API values (YYYY-MM-DD) — parse as local calendar date to avoid UTC shift
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split('-').map(Number);
    const date = new Date(y, m - 1, d);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

/** Format as dd/mm/yyyy. Returns em dash for null/invalid. */
export const formatDate = (value: string | number | Date | null | undefined): string => {
  const date = toValidDate(value);
  if (!date) return '—';
  return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)}/${date.getFullYear()}`;
};

/** Format as dd/mm/yyyy HH:mm:ss. Returns em dash for null/invalid. */
export const formatDateTime = (value: string | number | Date | null | undefined): string => {
  const date = toValidDate(value);
  if (!date) return '—';
  const datePart = `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)}/${date.getFullYear()}`;
  const timePart = `${pad2(date.getHours())}:${pad2(date.getMinutes())}:${pad2(date.getSeconds())}`;
  return `${datePart} ${timePart}`;
};
